import React, { useState } from "react";

import {
	ChevronDownIcon,
	ChangeableCheckbox,
} from "../../../../../resource/icons";
import Streets from "./streets";

const Region = ({ region }) => {
	const [regionOpened, setRegionOpened] = useState(false);
	return (
		<div>
			<div
				className="branch"
				key={`branch-${region.regionId || region.region}`}
				onClick={() => setRegionOpened(!regionOpened)}
			>
				<label
					onClick={(e) => {
						e.stopPropagation();
					}}
					className="checkbox-label"
				>
					<input
						type="checkbox"
						className="true-checkbox"
						checked={region.checked()}
						onChange={(e) => region.onSelectChange(e)}
					/>
					<ChangeableCheckbox
						indeterminateCheckBox={region.indeterminate()}
						checked={region.checked()}
						className="checkbox"
					/>
				</label>
				<span>{region.region}</span>
				<div className="spacer" />
				<ChevronDownIcon className={regionOpened && "chevron-opened"} />
			</div>
			{regionOpened && <Streets streets={region.streets} />}
		</div>
	);
};

export default Region;
